export enum i18nKeys {
  Pano,
  Scan,
  FlightScheduledDateTitle,
  FlightExifDateTitle,

  UploadsListActivity,
  UploadsListActivityError,
  UploadsListActivityErrorDetails,
  UploadsListNoUploads,

  FlightDateConfirmationDatePickerDatePlaceholder,
  FlightDateConfirmationDatePickerExistingScheduleErrorMessage,

  InvoicingSubmitInvoice,
  InvoicingDescription,
  InvoicingSelectDateButtonDescription,
  InvoicingScanCostsPlaceholder,
  InvoicingScanCostsTitle,
  InvoicingPanoCostsPlaceholder,
  InvoicingPanoCostsTitle,
  InvoicingOtherCostsPlaceholder,
  InvoicingOtherCostsTitle,
  InvoicingTotalCostsTitle,
  InvoicingPaymentLinkPlaceholder,
  InvoicingPaymentLinkTitle,
  InvoicingPaymentLinkErrorMessage,
  InvoicingSubmitButtonTitle,
  InvoicingSubmitAnywayButtonTitle,
  InvoicingSentButtonTitle,
  InvoicingSendAnotherTitle,
  InvoicingPdfFileInputTitle,
  InvoicingPdfFileButtonTitle,
  InvoicingPdfFileButtonPendingTitle,
  InvoicingUploadErrorHeader,
  InvoicingNoCostsErrorDescription,
  InvoicingNoLinkErrorHeader,
  InvoicingDatePickerStartDatePlaceholder,
  InvoicingDatePickerEndDatePlaceholder,
  InvoicingStartDateErrorDescription,
  InvoicingEndDateErrorDescription,
  InvoicingExpectedCostsFetchErrorHeader,
  InvoicingCostsNotMatchErrorHeader,
  InvoicingBillableUploadsTitle,
  InvoicingBillableUploadsTotalAmount,
  InvoicingBillableUploadsListFirstColTitle,
  InvoicingBillableUploadsListSecondColTitle,
  InvoicingBillableUploadsSelectDatesErrorMessage,
  InvoicingBillableUploadsNoUploadErrorMessage,
  InvoicingBillableUploadsLoaderTitle,
  InvoicingBillableUploadsProcessingInfoMessage,
  InvoicingBillableUploadsProcessingStatus,
  InvoicingBillableUploadsFetchErrorMessage,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type literals = { [key in i18nKeys]: ((arg: any) => string) | string };
